// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const design: Styleguide["design"] = {
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    // Store Custom Code
    typography: {
        fontFamily: {
            title: `'Roboto', sans-serif, 'Open Sans', 'Lato'`,
            base: `'Roboto', sans-serif, 'Open Sans', 'Lato'`,
        },
    },
    button: {
        field: {
            scaling: 0.1,
        },
    },
    menu: {
        mainNavigation: {
            megaMenuFullWidth: true,
        },
    },
    common: {
        contentRadius: "0",
    },
};
export default design;
